// extracted by mini-css-extract-plugin
module.exports = {"centered":"VNDialogs_centered__ZG-u2"};